const func = obj => Object.keys( obj ).reduce( (array, key) =>  { return Array.isArray(obj[key]) ? obj[key] : func(obj[key]) }, [] )

export default item => func(item).length > 0;